import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import { Button } from "primereact/button";
import { connect } from "react-redux";
import { Dialog } from "primereact/dialog";
import VerifyProduct from "../models/VerifyProduct";
import { productAuthenticationActions, productMasterActions } from "../actions";
import { handleResponse } from "../helpers";
import toyo from "./../assets/images/Header_logo.png";
import sucessIcon from "./../assets/images/orignal toyo.png";
import fakeIcon from "./../assets/images/wrong-code.png";
import { Rating } from "primereact/rating";
import Logo from "./../assets/images/login_logo.png";
import "./ProductAuthentication.css";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterIcon,
  TwitterShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  LinkedinShareButton,
  LinkedinIcon,
  EmailShareButton,
  EmailIcon,
} from "react-share";

export class ProductAuthentication extends Component {
  constructor(props) {
    super(props);
    this.clsVerifyProduct = new VerifyProduct();
    this.state = {
      formIsValid: false,
      IsLocation: false,
      ratingBox: false,
      shareBox: false,
      VerifyProduct: {},
      rating: null,
      showDialog: false,
      VerificationMode: "Web",
      QrData: window.location.href,
      VerificationType: 2,
      VerificationId: 0,
      displayBasic: false,
      UserId: "",
      SeqNo: "",
      Name: "",
      email: "",
      MobileNo: "",
      UserFeedback: "",
      showVideo: true,
      photoIndex: 0,
      isOpen: false,
      socialLinks: "",
      isVerifying: true,
      formError: {
        Name: null,
        email: null,
        MobileNo: null,
        UserFeedback: null,
      },
    };

    this.submitForm = this.submitForm.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.hideFunc = this.hideFunc.bind(this);
    this.onHide = this.onHide.bind(this);
    this.openDialog = this.openDialog.bind(this);
    this.updateRating = this.updateRating.bind(this);
    this.ImgModal = this.ImgModal.bind(this);
    this.reverseGeocodeLatLngAndVerifyProduct =
      this.reverseGeocodeLatLngAndVerifyProduct.bind(this);
    const urlParams = new URLSearchParams(window.location.search);
    const parmUid = urlParams.get("uid");
    //const curl = window.location.href;
    this.clsVerifyProduct.QrData = this.state.QrData;
    this.clsVerifyProduct.VerificationType = this.state.VerificationType;
    this.findMe();
  }

  //get reverse geo code
  reverseGeoCode(lat, long) {
    // tslint:disable-next-line:max-line-length
    const requestOptions = {
      method: "GET",
    };
    return fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${long}&zoom=18&addressdetails=1`,
      requestOptions
    ).then(handleResponse);
    //   return fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${long}&zoom=18&addressdetails=1`);
  }

  //to trigger api on page call
  componentDidMount() {
    const caches = window.caches;
    if (window.caches) {
      window.caches.keys().then(async function (names) {
        await Promise.all(names.map((name) => window.caches.delete(name)));
      });
    }

    // const urlParams = new URLSearchParams(window.location.search);
    // const parmUid = urlParams.get('uid');

    // const curl = window.location.href;

    // this.clsVerifyProduct.verificationMode = this.state.verificationMode;
    // this.clsVerifyProduct.qrData = this.state.qrData;
    // this.clsVerifyProduct.verificationType = this.state.verificationType;
    // this.clsVerifyProduct.UID = parmUid;
    this.props.getAllProductsData();

    // setTimeout(() => {
    //     // this.findMe();
    // }, 1000);
    // this.findMe();
  }

  componentDidUpdate(prevProps) {
    if (
      this.state.isVerifying &&
      ((prevProps.Verifying && !this.props.Verifying) ||
        (this.props.ProductAuthenticationData != null &&
          prevProps.ProductAuthenticationData == null))
    ) {
      this.setState({ isVerifying: false });
    }
  }

  // get verify product list data
  GetVerifyProduct(productAuthReq) {
    this.setState({
      IsLocation: false,
    });

    this.props.verifyProduct(productAuthReq);
  }
  //to hide function
  hideFunc() {
    this.setState({
      displayBasic: false,
    });
  }

  //to validate feedback form
  validateFeedback(value, name) {
    let errors = this.state.formError;
    let IsValid = true;
    switch (name) {
      case "Name":
        if (!value || value.length < 1) {
          IsValid = false;
          errors.Name = "Please enter your name.";
        } else if (value.length >= 1) {
          if (!value.match(/^[a-zA-Z-,]+(\s{0,1}[a-zA-Z-, ])*$/)) {
            IsValid = false;
            errors.Name = "Please enter only alphabet.";
          } else errors.Name = "";
        } else errors.Name = "";
        break;
      case "email":
        if (!value || value.length < 1) {
          IsValid = false;
          errors.email = "Please enter your email-id.";
        } else if (value && value.length > 1) {
          if (!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
            IsValid = false;
            errors.email = "Please enter valid email-id.";
          } else errors.email = "";
        } else errors.email = "";
        break;
      case "MobileNo":
        if (!value || value.length < 1) {
          IsValid = false;
          errors.MobileNo = "Please enter your mobile no.";
        } else if (value && value.length > 1) {
          if (!value.match(/^[6-9]\d{9}$/)) {
            IsValid = false;
            errors.MobileNo = "Please enter valid mobile no.";
          } else errors.MobileNo = null;
        } else errors.MobileNo = "";
        break;
      case "UserFeedback":
        if (!value || value.length < 1) {
          IsValid = false;
          errors.UserFeedback = "Please enter your feedback.";
        } else errors.UserFeedback = "";
        break;

      default:
        break;
    }

    return IsValid;

    // let errors = this.state.formError;
    // let formFeedIsValid = true;

    // switch (name) {
    //     case 'Name':
    //         if (value === null || value.length < 1) {
    //             formFeedIsValid = false;
    //             errors.Name = "Please enter your name.";
    //         } else if (value.length >= 1) {
    //             if (!value.match(/^[a-zA-Z-,]+(\s{0,1}[a-zA-Z-, ])*$/)) {
    //                 formFeedIsValid = false;
    //                 errors.Name = "Please enter only alphabet.";
    //             } else errors.Name = null
    //         } else errors.Name = null
    //         break;
    //     case 'email':
    //         if (value === null || value === '' || value.length >= 1) {
    //             /* eslint-disable */
    //             if (!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
    //                 formFeedIsValid = false;
    //                 errors.email = "Please enter valid email-id.";
    //             } else errors.email = null
    //             /* eslint-enable */
    //         } else errors.email = null
    //         break;
    //     case 'MobileNo':
    //         if (value === null || value.length < 1) {
    //             formFeedIsValid = false;
    //             errors.MobileNo = "Please enter your mobile no.";
    //         }
    //         else if (value.length >= 1) {
    //             if (!value.match(/^[6-9]\d{9}$/)) {
    //                 formFeedIsValid = false;
    //                 errors.MobileNo = "Please enter valid mobile no.";
    //             } else errors.MobileNo = null
    //         } else errors.MobileNo = null
    //         break;
    //     case 'UserFeedback':
    //         if (value === null || value.length < 1) {
    //             formFeedIsValid = false;
    //             errors.UserFeedback = "Please enter your feedback.";
    //         } else errors.UserFeedback = null
    //         break;
    //     default:
    //         break;
    // }

    // return formFeedIsValid;
  }

  ImgModal() {
    var modal = document.getElementById("myModal");
    // Get the image and insert it inside the modal - use its "alt" text as a caption
    var img = document.getElementById("myImg");
    var modalImg = document.getElementById("img01");
    // var captionText = document.getElementById("caption");
    img.onclick = function () {
      modal.style.display = "block";
      modalImg = document.getElementById("img01");
      // captionText.innerHTML = this.alt;
    };

    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("close")[0];

    // When the user clicks on <span> (x), close the modal
    span.onclick = function () {
      modal.style.display = "none";
    };
  }

  submitForm(event) {
    // const { name, value } = event.target;
    event.preventDefault();

    let isfeedfrmvalid = true;
    let checkerror = this.state.formError;
    Object.entries(checkerror).map(([key, value]) => {
      const val = this.state[key];
      let valid = this.validateFeedback(val, key);
      if (!valid) {
        this.setState({ checkerror: isfeedfrmvalid });
        isfeedfrmvalid = false;
      }

      return isfeedfrmvalid;
    });

    const feedbackData = {
      Name: this.state.Name,
      email: this.state.email,
      MobileNo: this.state.MobileNo,
      UserFeedback: this.state.UserFeedback,
      VerificationId: this.props.ProductAuthenticationData.VerificationId,
    };

    if (isfeedfrmvalid) {
      this.props.UpdateFeedback(feedbackData);
    }

    this.setState({ [feedbackData]: "" });
  }

  formReset() {
    this.setState({
      Name: "",
      email: "",
      MobileNo: "",
      UserFeedback: "",
      formError: {
        Name: null,
        email: null,
        MobileNo: null,
        UserFeedback: null,
      },
    });
    let errors = this.state.formError;
    Object.entries(errors).map(([key, value]) => {
      errors[key] = "";
    });
  }

  updateRating(productId, verificationId, event) {
    this.setState({ rating: event.value });

    var data = {
      ProductId: productId,
      ProductRating: event.value,
      SeqNo: event.value,
      VerificationId: verificationId,
    };

    if (productId) {
      this.props.updateRating(data);
    } else {
    }
  }

  handleChange(event) {
    const { name, value } = event.target;
    let errors = this.state.scratchError;

    this.validateFeedback(value, name);
    this.setState({ errors, [name]: value });
  }
  onHide() {
    this.props.onHideShow(false);
  }

  openDialog() {
    this.props.onHideShow(true);
  }

  //to find  location
  findMe() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.showPosition(position);
        },
        (denied) => {
          // alert(JSON.stringify(denied));
          this.GetVerifyProduct(this.clsVerifyProduct);
        },
        { enableHighAccuracy: true, maximumAge: 10000 }
      );
    } else {
      this.GetVerifyProduct(this.clsVerifyProduct);
    }
  }
  //to get exact longitude and latitude
  showPosition(position) {
    this.clsVerifyProduct.Userlongitude = position.coords.longitude;
    this.clsVerifyProduct.Userlatitude = position.coords.latitude;
    this.reverseGeocodeLatLngAndVerifyProduct();
  }
  //to get location
  reverseGeocodeLatLngAndVerifyProduct() {
    // tslint:disable-next-line: max-line-length
    this.reverseGeoCode(
      this.clsVerifyProduct.Userlatitude,
      this.clsVerifyProduct.Userlongitude
    ).then(
      (response) => {
        const res = response;
        this.clsVerifyProduct.UserCity = res.address.state_district;
        this.clsVerifyProduct.UserState = res.address.state;
        this.clsVerifyProduct.UserCountry = res.address.country;
        this.clsVerifyProduct.UserZip = res.address.postcode;
        this.clsVerifyProduct.UserAddress = res.display_name;
        this.setState({
          Location: res.display_name,
        });
        this.GetVerifyProduct(this.clsVerifyProduct);
      },
      (error) => {
        // alert(JSON.stringify(error))
        this.GetVerifyProduct(this.clsVerifyProduct);
      }
    );
  }

  render() {
    const data = this.props.ProductAuthenticationData;
    const isVerifying = this.state.isVerifying && data == null;
    const isGenuine = data != null && data.ResponseCode == "200";

    return (
      <section className="pa2-page">
        <header className="pa2-header">
          <img src={toyo} alt="Toyo" className="pa2-header-logo" />
        </header>

        <main className="pa2-main">
          {isVerifying ? (
            <div className="pa2-card pa2-card-loading">
              <div className="pa2-spinner"></div>
              <p className="pa2-loading-text">Verifying product...</p>
            </div>
          ) : isGenuine ? (
            <>
              {data.GenuineAudio != null ? (
                <audio
                  controls
                  autoPlay
                  src={data.GenuineAudio}
                  id="pm3paly"
                  hidden
                />
              ) : (
                ""
              )}

              <div className="pa2-banner pa2-banner-success">
                <img src={sucessIcon} alt="" className="pa2-banner-icon" />
                <span>{data.ResponseMessage}</span>
              </div>

              <div className="pa2-card">
                <div className="pa2-brand-logo" onClick={this.ImgModal}>
                  <img
                    id="myImg"
                    src={toyo}
                    alt="Brand logo"
                  />

                  <div
                    id="myModal"
                    className="modal pa2-lightbox-modal"
                    style={{ display: "none" }}
                  >
                    <span className="close pa2-lightbox-close">&times;</span>
                    <img
                      className="modal-content pa2-modal-img"
                      src={toyo}
                      id="img01"
                    />
                    <div id="caption"></div>
                  </div>
                </div>

                <div className="pa2-product-media">
                  <img
                    className="pa2-product-img"
                    src={data.ProductImage == "" ? Logo : data.ProductImage}
                    alt={data.ProductName}
                  />
                </div>

                <h1 className="pa2-product-name">{data.ProductName}</h1>

                {data.PromotionalMessage != null ? (
                  <p className="pa2-promo-message">
                    {data.PromotionalMessage}
                  </p>
                ) : (
                  ""
                )}

                <div className="pa2-actions">
                  {data.IsRating != null && data.IsRating != "0" ? (
                    <button
                      type="button"
                      className="pa2-action-btn"
                      onClick={() =>
                        this.setState({ ratingBox: !this.state.ratingBox })
                      }
                    >
                      <i className="fa fa-star-o" aria-hidden="true"></i>
                      <span>
                        Rating{" "}
                        {this.props.Rating && this.props.Rating.ProductRating
                          ? this.props.Rating.ProductRating
                          : data.ProductRating}
                        (
                        {this.props.Rating && this.props.Rating.TotalRating
                          ? this.props.Rating.TotalRating
                          : data.TotalRating == null
                          ? 0
                          : data.TotalRating}
                        )
                      </span>
                    </button>
                  ) : null}

                  {data.IsFeedback != null && data.IsFeedback != "0" ? (
                    <button
                      type="button"
                      className="pa2-action-btn"
                      onClick={() => this.openDialog()}
                    >
                      <i
                        className="fa fa-pencil-square-o"
                        aria-hidden="true"
                      ></i>
                      <span>Feedback</span>
                    </button>
                  ) : null}

                  {data.IsShare != null && data.IsShare != "0" ? (
                    <button
                      type="button"
                      className="pa2-action-btn"
                      onClick={() =>
                        this.setState({ shareBox: !this.state.shareBox })
                      }
                    >
                      <i className="fa fa-share-alt" aria-hidden="true"></i>
                      <span>Share</span>
                    </button>
                  ) : null}
                </div>

                {this.state.ratingBox ? (
                  <div className="pa2-panel">
                    {data.isRated == 0 ? (
                      <Rating
                        cancel={false}
                        value={this.state.rating}
                        onChange={(e) =>
                          this.updateRating(
                            data.ProductId,
                            data.VerificationId,
                            e
                          )
                        }
                      />
                    ) : (
                      <Rating
                        cancel={false}
                        readonly
                        value={data.ProductRating}
                        onChange={(e) =>
                          this.updateRating(
                            data.ProductId,
                            data.VerificationId,
                            e
                          )
                        }
                      />
                    )}
                  </div>
                ) : null}

                {this.state.shareBox ? (
                  <div className="pa2-panel pa2-share-panel">
                    <FacebookShareButton
                      url={data.ShareURL}
                      quote={data.ShareURL}
                    >
                      <FacebookIcon size={32} round />
                    </FacebookShareButton>
                    <TwitterShareButton url={data.ShareURL} quote={data.ShareURL}>
                      <TwitterIcon size={32} round />
                    </TwitterShareButton>
                    <WhatsappShareButton
                      url={data.ShareURL}
                      quote={data.ShareURL}
                    >
                      <WhatsappIcon size={32} round />
                    </WhatsappShareButton>
                    <LinkedinShareButton
                      url={data.ShareURL}
                      quote={data.ShareURL}
                    >
                      <LinkedinIcon size={32} round />
                    </LinkedinShareButton>
                    <EmailShareButton url={data.ShareURL} quote={data.ShareURL}>
                      <EmailIcon size={32} round />
                    </EmailShareButton>
                  </div>
                ) : null}

                {data.ProductSpecification != null ? (
                  <div className="pa2-spec-grid">
                    {data.ProductSpecification.map((x, i) => (
                      <div className="pa2-spec-row" key={i}>
                        <div className="pa2-spec-key">{x.Key}</div>
                        <div className="pa2-spec-value">
                          {x.Key == "Website" ? (
                            <a href={x.Value} target="_blank" rel="noopener noreferrer">
                              {x.Value}
                            </a>
                          ) : (
                            x.Value
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>

              <div className="pa2-social-footer">
                <ul className="pa2-social-list">
                  <li className="pa2-social-item pa2-social-facebook">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <i className="fa fa-facebook" aria-hidden="true"></i>
                    </a>
                  </li>
                  <li className="pa2-social-item pa2-social-twitter">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <i className="fa fa-twitter" aria-hidden="true"></i>
                    </a>
                  </li>
                  <li className="pa2-social-item pa2-social-instagram">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <i className="fa fa-instagram" aria-hidden="true"></i>
                    </a>
                  </li>
                  <li className="pa2-social-item pa2-social-google">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <i className="fa fa-google" aria-hidden="true"></i>
                    </a>
                  </li>
                  <li className="pa2-social-item pa2-social-whatsapp">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <i className="fa fa-whatsapp" aria-hidden="true"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </>
          ) : (
            <div className="pa2-card pa2-card-fail">
              {(data != null && data.FakeAudio) === true ? (
                <audio
                  controls
                  autoPlay
                  src={data.FakeAudio}
                  id="pm3paly"
                  hidden
                />
              ) : (
                ""
              )}

              <div className="pa2-banner pa2-banner-fail">
                <img src={fakeIcon} alt="" className="pa2-banner-icon" />
              </div>

              {data != null ? (
                <h2 className="pa2-fail-message">{data.ResponseMessage}</h2>
              ) : (
                ""
              )}

              <button
                type="button"
                className="pa2-primary-btn"
                onClick={() => this.openDialog()}
              >
                Feedback
              </button>
            </div>
          )}
        </main>

        <Dialog
          header="Feedback Form"
          modal
          dismissableMask={true}
          visible={this.props.ShowDialogFeedback}
          className="pa2-feedback-dialog"
          onHide={this.onHide}
        >
          <form onSubmit={this.submitForm} className="pa2-feedback-form">
            <div className="row">
              <div className="col-md-6 pt-2 pa2-field">
                <TextField
                  id="standard-basic"
                  size="small"
                  onChange={this.handleChange}
                  variant="outlined"
                  name="Name"
                  value={this.state.Name}
                  className="fullwidth"
                  label="Name*"
                />
                {this.state.formError.Name !== "" ? (
                  <div className="error">{this.state.formError.Name}</div>
                ) : (
                  ""
                )}
              </div>

              <div className="col-md-6 pt-2 pa2-field">
                <TextField
                  id="standard-basic"
                  size="small"
                  onChange={this.handleChange}
                  variant="outlined"
                  name="email"
                  value={this.state.email}
                  className="fullwidth"
                  label="Email*"
                />
                {this.state.formError.email !== "" ? (
                  <div className="error">{this.state.formError.email}</div>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-6 pt-2 pa2-field">
                <TextField
                  id="standard-basic"
                  size="small"
                  onChange={this.handleChange}
                  variant="outlined"
                  name="MobileNo"
                  value={this.state.MobileNo}
                  className="fullwidth"
                  label="Mobile number*"
                />
                {this.state.formError.MobileNo !== "" ? (
                  <div className="error">{this.state.formError.MobileNo}</div>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-6 pt-2 pa2-field">
                <TextField
                  id="standard-basic"
                  size="small"
                  onChange={this.handleChange}
                  variant="outlined"
                  name="UserFeedback"
                  value={this.state.UserFeedback}
                  className="fullwidth"
                  label="Feedback*"
                />
                {this.state.formError.UserFeedback !== "" ? (
                  <div className="error">
                    {this.state.formError.UserFeedback}
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-12 pa2-feedback-submit">
                <Button label="Submit" icon="pi pi-check" />
              </div>
            </div>
          </form>
        </Dialog>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  //console.log(state.product.items);
  //console.log('state.productAuthentication.feedback', state.productAuthentication.showDialogFeedback);
  //console.log('state.productAuthentication.items', state.productAuthentication.items);
  //console.log('state.productAuthentication.items[0]', (state.productAuthentication.items && state.productAuthentication.items.length) > 0 ? state.productAuthentication.items[0] : null);
  return {
    ProductsData: state.product.items,
    Rating: state.productAuthentication.rating,
    ProductAuthenticationData:
      (state.productAuthentication.items &&
        state.productAuthentication.items.length) > 0
        ? state.productAuthentication.items[0]
        : null,
    ShowDialogFeedback: state.productAuthentication.showDialogFeedback,
    Verifying: state.productAuthentication.creating,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    verifyProduct: (productAuth) =>
      dispatch(productAuthenticationActions.verifyProduct(productAuth)),
    UpdateFeedback: (feedback) =>
      dispatch(productAuthenticationActions.UpdateFeedback(feedback)),
    updateRating: (ratingData) =>
      dispatch(productAuthenticationActions.updateRating(ratingData)),
    onHideShow: (isbool) =>
      dispatch(productAuthenticationActions.onHideShow(isbool)),
    getAllProductsData: () =>
      dispatch(productMasterActions.getAllProductsData()),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductAuthentication);
